import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { ESTransport } from "./ESTransport";
export var MockESTransport =
/*#__PURE__*/
function (_ESTransport) {
  _inherits(MockESTransport, _ESTransport);

  function MockESTransport() {
    _classCallCheck(this, MockESTransport);

    return _possibleConstructorReturn(this, _getPrototypeOf(MockESTransport).apply(this, arguments));
  }

  _createClass(MockESTransport, [{
    key: "search",
    value: function search(query) {
      return Promise.resolve(query);
    }
  }]);

  return MockESTransport;
}(ESTransport);